import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'nd-card',
  template: `<div [ngClass]="'nd-card'" [attr.id]="cardId" [ngStyle]="style" [class]="styleClass">
    <ng-content></ng-content>
</div>
`,
  styles: [`:host{display:inline-block}.nd-card{border-radius:2px;background-color:#fff;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.3);box-shadow:0 1px 3px 0 rgba(0,0,0,.3);min-width:100px;min-height:100px;overflow:hidden;position:relative}`]
})
export class CardComponent implements OnInit {

  @Input() cardId: string;
  @Input() styleClass: string;
  @Input() style: any;

  constructor() { }

  ngOnInit() {
  }

}
